import { actionGenerator } from '../../../../../redux/actionGenerator';

import { ECommercialOwnershipVerificationFormViewFields, EIdentificationPersonType } from '../enums';
import { TCommercialOwnershipVerificationFormViewState } from '../types';

import { onChangeInput } from './utils';
import { EValidateActionTypes } from './enums';

export const setCadastralNumberFieldValueAction = onChangeInput(
  actionGenerator<ECommercialOwnershipVerificationFormViewFields.CadastralNumber, string>(
    ECommercialOwnershipVerificationFormViewFields.CadastralNumber,
  ),
);

export const setInnFieldValueAction = actionGenerator<ECommercialOwnershipVerificationFormViewFields.Inn, string>(
  ECommercialOwnershipVerificationFormViewFields.Inn,
);

export const setLastNameFieldValueAction = onChangeInput(
  actionGenerator<ECommercialOwnershipVerificationFormViewFields.LastName, string>(
    ECommercialOwnershipVerificationFormViewFields.LastName,
  ),
);

export const setFirstNameFieldValueAction = onChangeInput(
  actionGenerator<ECommercialOwnershipVerificationFormViewFields.FirstName, string>(
    ECommercialOwnershipVerificationFormViewFields.FirstName,
  ),
);

export const setSecondNameFieldValueAction = onChangeInput(
  actionGenerator<ECommercialOwnershipVerificationFormViewFields.SecondName, string>(
    ECommercialOwnershipVerificationFormViewFields.SecondName,
  ),
);

export const setIdentificationPersonTypeFieldValueAction = onChangeInput(
  actionGenerator<ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType, EIdentificationPersonType>(
    ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType,
  ),
);

export const validateAllAction = actionGenerator<EValidateActionTypes.ValidateAll>(EValidateActionTypes.ValidateAll);

export const validateByFieldAction = actionGenerator<
  EValidateActionTypes.ValidateByField,
  ECommercialOwnershipVerificationFormViewFields
>(EValidateActionTypes.ValidateByField);

export const resetState = actionGenerator<
  EValidateActionTypes.ResetState,
  Partial<TCommercialOwnershipVerificationFormViewState> | undefined
>(EValidateActionTypes.ResetState);

export const setCompanyName = actionGenerator<
  ECommercialOwnershipVerificationFormViewFields.CompanyName,
  string | null | undefined
>(ECommercialOwnershipVerificationFormViewFields.CompanyName);
